import React, { Fragment } from 'react'
import DetailsRow from './DetailsRow'
import './Details.css'
import i18n from '../../../i18n'
import { useSelector } from 'react-redux'

const DetailsTable = () => {
  const data = useSelector(state => state.fundData.data)
  const screenedFunds = useSelector(state => state.params.screenedFunds)
  const hasModels = screenedFunds.some(fund => fund.type === 'model');
  const hasBlends = screenedFunds.some(fund => fund.type === 'blend');
  const params = useSelector(state => state.params)
  const wtRegion =params.wtRegion

  const filteredData = data.filter(x => !['BMK', 'WTIDX', 'BLEND'].includes(x.type))


  const renderRows = () => {
    return filteredData.map(fund => {
        return <DetailsRow key={fund.externalID} fund={fund} wtRegion={wtRegion} />
      })
  }

  const renderHeader = () => {
    const asOfDate = data[0].stdPerformance && data[0].stdPerformance[0].asOfDate ? new Date(data[0].stdPerformance[0].asOfDate).toLocaleDateString() : new Date().toLocaleDateString()
    const title = hasModels ? 'FUND AND MODEL DETAILS' : 'FUND DETAILS'


    const cols = wtRegion === 'US' ? 9 : 7

    if (filteredData.length === 0) {
      return null
    }
    return (
      <thead>
        <tr>
          <th colSpan={cols} className='textLeft'>
            {title}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>
            {i18n.t('Ticker')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Website')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Filings')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Inception Date')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Gross Expense Ratio')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Net Expense Ratio')}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th scope='col' className='textCenter'>
                {i18n.t('30-Day SEC Yield, Subsidized')} ({i18n.t('as of')} {asOfDate})
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('30-Day SEC Yield, Unsubsidized')} ({i18n.t('as of')} {asOfDate})
              </th>
            </Fragment>
          )}
          <th scope='col' className='textCenter'>
            {i18n.t('Notes')}
          </th>
        </tr>
      </thead>
    )
  }

  return (
    <Fragment>
      {filteredData.length > 0 && (
        <Fragment>
          <div className='table-responsive'>
            <table className='table tableFC'>
              {renderHeader()}
              <tbody>{renderRows()}</tbody>
            </table>
          </div>
          <div className='subjectToChange'>
            * {i18n.t('subject to change')} {i18n.t('fund-info')}
            <br />
            {getRatioMethodForFootNote(hasModels, hasBlends)}
          </div>      
        </Fragment>
      )}
    </Fragment>
  );
};

export default DetailsTable

function getRatioMethodForFootNote(hasModels, hasBlends) {
  let ratioMethod = null;
  if (hasModels) {
    ratioMethod = '* ' + i18n.t(hasBlends ? 'model_blended_ratio_method' : 'model_ratio_method');
  } else if (hasBlends) {
    ratioMethod = '* ' + i18n.t('blended_ratio_method');
  }
  return ratioMethod;
}

